import { FunctionComponent } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { theme } from '@flos/react-components';
import RouterApp from './../router/RouterApp';
import { IAppProps } from '../common/interface/IAppProvider';
import { useGlobalState } from '../common/context/AppContext';
import { OnsaHeader } from '../components/onsa-header/onsa-header';
import OnsaBanner from '../components/OnsaBanner/OnsaBanner';
import { ProgressBar } from '../components/progress-bar/progress-bar';
import './App.css';

export const App: FunctionComponent<IAppProps> = (props): JSX.Element => {
    const { actualStep, createPackage, bannerText, overlayText, resourcesReady, refreshFromCache } = useGlobalState();

    return (
        <div className="onsa-main-wrapper">
            <OnsaHeader />
            <div className="onsa-content-area">
                {document.URL.includes('/pakker') && createPackage?.hasProductDiscount && (
                    <OnsaBanner variant="top" body={bannerText} enableToggle={!!overlayText} />
                )}
                <ShowProgressBar props={props} actualStep={actualStep} />
                <Container fixed>
                    <MuiThemeProvider theme={theme}>
                        <div className="onsa-main-inner-wrapper">
                            {resourcesReady && refreshFromCache && <RouterApp {...props} />}
                        </div>
                    </MuiThemeProvider>
                </Container>
            </div>
        </div>
    );
};

interface IProgressBar {
    actualStep: number;
    props: any;
}
const ShowProgressBar = ({ actualStep, props }: IProgressBar): JSX.Element => {
    const actualStepLow = 10;
    const actualStepHigh = 15;

    if (
        ((actualStep < actualStepLow || actualStep > actualStepHigh) && props.pageType === 'app') ||
        props.pageType === 'receipt'
    ) {
        return <></>;
    }

    return (
        <div className="progress-bar-wrapper">
            <div role="progressbar" className="progress-bar-inner-wrapper">
                <ProgressBar {...props} />
            </div>
        </div>
    );
};

export default App;
